// extracted by mini-css-extract-plugin
module.exports = {"scrollBar":"scrollBar-509ac388","hide":"hide-81fb7dfd","scrollTrack":"scrollTrack-7e44002d","scrollHandle":"scrollHandle-9e887ac5"};